import { useState, useEffect, useCallback } from 'react';
import { authenticatedFetch } from '../../../../utils/api';

export function useOccurrenceHistory(incidentId) {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchHistory = useCallback(async (id) => {
        if (!id) return;
        setLoading(true);
        try {
            const res = await authenticatedFetch(
                `/ManagerReport/GetOccurrenceHistory?incidentId=${id}`
            );
            if (res.ok) {
                const data = await res.json();
                setHistory(data);
            }
        } catch {
            setHistory([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        setHistory([]);
        fetchHistory(incidentId);
    }, [incidentId, fetchHistory]);

    return { history, loading };
}
